export default __webpack_public_path__ + "bd0ef65324c2fa316c53778f36e81899.svg";